import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useSelector} from "react-redux";
import config from "../../../../config/config";
import {RootStore} from "../../../../configureStore";
// import Anchor from "../../../HTMLEntities/Anchor";
import {NavItemsProps} from "../../types";
import {
    AbroadLogoMobile,
    // BottomFreeAssistanceButtonSection,
    // BottomFreeAssistanceDiv,
    // BottomFreeAssistanceWrapperDiv,
    // ContactUsCallIcon,
    // ContactUsHeadPhoneIcn,
    HamburgerHeader,
    Nav,
} from "../HeaderStyled";
import NavLink from "../NavLinks/NavLinks";

const NavItem: React.FC<NavItemsProps> = ({
    gnbData,
    navHoverActiveIndex,
    openHamburger,
    closeHamburger,
    navMenuHoverEnter,
    navMenuHoverLeave,
    handleHamburgerMainSection,
    navClickActiveIndex,
    isHamburgerOpen,
    navMenuClick,
}: NavItemsProps) => {
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);

    const renderNavGroups = useCallback(() => {
        return gnbData.map((group, index) => {
            let labelClasses = "menuTab-div fnt-wt melabel";

            if (navHoverActiveIndex != null && navHoverActiveIndex === index)
                labelClasses = labelClasses.concat(" active");

            let hamSectionActive = false;
            let mainSectionPlusIcon = "";

            if (navClickActiveIndex != null && navClickActiveIndex === `grp${index}`) {
                hamSectionActive = true;
                mainSectionPlusIcon = "minus-icon";
            }
            if (isMobile && navClickActiveIndex != null && navClickActiveIndex === `grp${index}`) {
                labelClasses = labelClasses.concat(" labelActiveTitle");
            }
            return (
                <li key={`grp${index}`} className="g_lev1">
                    <label
                        className={labelClasses}
                        onClick={() => handleHamburgerMainSection(`grp${index}`)}
                        onMouseEnter={() => navMenuHoverEnter(index)}
                        onMouseLeave={() => navMenuHoverLeave()}
                    >
                        {group.title}
                        <span className="drop-icon"></span>
                        <label
                            title="Toggle Drop-down"
                            className={`drop-icon ${mainSectionPlusIcon}`}
                        ></label>
                    </label>
                    <NavLink
                        navMenuHoverEnter={() => navMenuHoverEnter(index)}
                        navMenuHoverLeave={() => navMenuHoverLeave()}
                        hamSectionActive={hamSectionActive}
                        navGroupData={group}
                        navClickActiveIndex={navClickActiveIndex}
                        navHoverActiveIndex={navHoverActiveIndex}
                        groupIndex={index}
                        navMenuClick={navMenuClick}
                    />
                </li>
            );
        });
    }, [
        gnbData,
        navHoverActiveIndex,
        navClickActiveIndex,
        navMenuHoverEnter,
        navMenuClick,
        navMenuHoverLeave,
        handleHamburgerMainSection,
        isMobile,
    ]);
    const [isMounted, setIsMounted] = useState(false);
    // const utm_Webmedium = isMobile ? "mweb" : "dweb";
    // const needCounselingUrl = `/apply?utm_source=hamburger&utm_medium=${utm_Webmedium}&utm_campaign=NL`;
    useEffect(() => {
        setIsMounted(true);
    }, []);
    return useMemo(() => {
        let hamburgerClass = "main-menu cf";
        if (isMounted && isHamburgerOpen) {
            hamburgerClass = hamburgerClass.concat(" hamburger-open");
        }
        return (
            <Nav id="menu">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        openHamburger();
                    }}
                    className="panel-anchor"
                >
                    <label id="toggle-menu">
                        <p className="drop-icon"></p>
                        <p className="menu-cls">Menu</p>
                    </label>
                </a>
                <div className={hamburgerClass} id="mypanel">
                    <div className="lgn-section">
                        {isMobile && (
                            <HamburgerHeader>
                                <a href={`${config.SHIKSHA_STUDYABROAD_HOME}`}>
                                    <AbroadLogoMobile />
                                </a>
                                <i
                                    className="CrossIcon"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        closeHamburger();
                                    }}
                                >
                                    &times;
                                </i>
                            </HamburgerHeader>
                        )}
                        <ul>{renderNavGroups()}</ul>
                    </div>
                    {/* {isMobile && (
                        <BottomFreeAssistanceWrapperDiv>
                            <BottomFreeAssistanceDiv>
                                <strong>Get free assistance from us</strong>
                                <BottomFreeAssistanceButtonSection>
                                    <Anchor
                                        linkHref={needCounselingUrl}
                                        target={"_blank"}
                                        isPWALink={true}
                                        onClickHandle={(e: any) => {
                                            closeHamburger();
                                        }}
                                        displayStyle={{
                                            mobile: {
                                                fontWeight: "400",
                                                width: "100%",
                                                maxWidth: "100%",
                                            },
                                            laptop: {
                                                fontWeight: "400",
                                                width: "100%",
                                                maxWidth: "100%",
                                            },
                                        }}
                                    >
                                        <ContactUsHeadPhoneIcn />
                                        Get Free Counseling
                                    </Anchor>
                                    <Anchor
                                        linkHref={`tel:+91-8069474732`}
                                        displayStyle={{
                                            mobile: {
                                                width: "100%",
                                                maxWidth: "100%",
                                            },
                                            laptop: {
                                                width: "100%",
                                                maxWidth: "100%",
                                            },
                                        }}
                                    >
                                        <ContactUsCallIcon />
                                        Call <strong>08069474732</strong>
                                    </Anchor>
                                </BottomFreeAssistanceButtonSection>
                            </BottomFreeAssistanceDiv>
                        </BottomFreeAssistanceWrapperDiv>
                    )} */}
                </div>
            </Nav>
        );
    }, [
        isMobile,
        openHamburger,
        isHamburgerOpen,
        renderNavGroups,
        closeHamburger,
        isMounted,
        // needCounselingUrl,
    ]);
};

export default NavItem;
